import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { isLoginInProgress, peekPostLoginRedirect } from "../Utils/postLoginRedirect";
import { isAdminHost } from "../Utils/constants";

const PublicRoute = ({ children }) => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) return null; // o spinner

  if (isLoggedIn) {
    // El formulario de login maneja la redirección (evita carrera con /app).
    if (isLoginInProgress()) return null;

    const redirectTo = peekPostLoginRedirect();
    const fallback = isAdminHost() ? '/admin' : '/app';
    return <Navigate to={redirectTo || fallback} replace />;
  }

  return children;
};

export default PublicRoute;
